import {
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Renderer } from '@angular/compiler-cli/ngcc/src/rendering/renderer';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioComponent),
      multi: true,
    },
  ],
})
export class RadioComponent implements ControlValueAccessor {
  @Input() label = '';
  @Input() description? = '';
  // Value of the radio group selected by user
  @Input() value?: string | boolean;
  // Value of the radio button set by parent component
  @Input() radioValue?: string | boolean;
  @Input() name: string = '';
  @Input() selectedContentTemplate: TemplateRef<any> | null = null;

  disabled: boolean = false;

  @ViewChild('radioInput')
  radioInput: ElementRef | undefined;

  propagateChange = (_: any) => {};
  onTouch = (_: any) => {};

  constructor(private renderer: Renderer2) {}

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(
      this.radioInput?.nativeElement,
      'disabled',
      isDisabled,
    );

    this.disabled = isDisabled;
  }

  toggleCheck(event: any) {
    this.value = this.radioValue;
    this.propagateChange(this.value);
  }
}
